
var windowHeight = document.documentElement.clientWidth
var windowWidth = document.documentElement.clientHeight

const onWindowResize = (callback) => {
  window.onresize = () => {
    return (() => {
      windowHeight = document.documentElement.clientHeight // 实时屏幕高度
      windowWidth = document.documentElement.clientWidth // 实时屏幕宽度
      // console.log('实时屏幕高度：', windowHeight)
      // console.log('实时屏幕宽度：', windowWidth)
      callback(windowWidth, windowHeight)
    })()
  }
}

const offWindowResize = () => {
  window.onresize = null
}

const getWindowSize = () => {
  const size = {}
  size.width = windowWidth
  size.height = windowHeight
  return size
}

export { onWindowResize, offWindowResize, getWindowSize }
